// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__15PgZ","left":"InfoRow_left__17MH7"};